export enum FormRiskEntrySourceType {
  Arcadia = 'arcadia',
  User = 'user',
}
